import { useQuery } from "@tanstack/react-query";
import { useFieldArray } from "react-hook-form";
import { FaRegTrashCan } from "react-icons/fa6";
import { fetchCategories, fetchSlotNames } from "../../../utils/apiUtils";
import Select from 'react-select';
import { useState } from "react";
import { AsyncPaginate } from "react-select-async-paginate";
import { customStyles } from "../../../utils/styleUtils";
import { loadRiders } from "../../../utils/optionLoaderUtils";

const step = 18
const StepEighteen = ({ activeStep, control, payload, getValues }) => {
    if (activeStep !== step) return;

    const [activeSwitch, setActiveSwitch] = useState('rider');
    const [selectedRider, setSelectedRider] = useState()
    const [selectedCategoryOption, setSelectedCategoryOption] = useState(null); // Initialize with null for no selection

    const template = getValues("template")
    const extraDefaultComponents = getValues("extraDefaultComponents")

    const findCategories = (obj, categories = []) => {
        for (const [key, value] of Object.entries(obj)) {
            if (key === 'category' || key === 'slotName') {
                categories.push(value);
            } else if (value && typeof value === 'object') {
                findCategories(value, categories);
            }
        }
        return categories;
    };

    const selectedCategories = findCategories(getValues());

    const { data: categoriesOptions, isError, error } = useQuery({
        queryKey: ['categories', template?.value],
        queryFn: async () => await fetchSlotNames(), //fetchCategories(template?.additional?.benefitPlanTemplateKey),
        select: (categories) => {
            return categories.filter((category) => {
                return !selectedCategories.includes(category.value);
            });
        },
        enabled: !!template
    })

    const { fields: extraRidersFields, remove, insert } = useFieldArray({
        control, // control props comes from useForm (optional: if you are using FormProvider)
        name: "extraRiders", // unique name for your Field Array
    });

    return (
        <>

            <div className="switch" style={{ width: 'fit-content', }}>
                {/* <p className={`option ${activeSwtich === "UI" ? "active" : ""}`} onClick={() => setActiveSwitch("UI")}>
                        UI
                    </p> */}
                <p
                    className={`option ${activeSwitch === "rider" ? "active" : ""}`}
                    onClick={() => setActiveSwitch("rider")}>
                    Rider
                </p>
                <p
                    className={`option ${activeSwitch === "component" ? "active" : ""}`}
                    onClick={() => setActiveSwitch("component")}>
                    Component
                </p>

            </div>

            {isError && <div className="danger">{error?.message}</div>}
            {activeSwitch === 'component' ? <>
                <p style={{ fontSize: '1.2rem', fontWeight: '600', padding: '2rem 0rem 1rem 0rem' }}>Extra Default components</p>
                <div style={{ padding: '1rem 0rem', display: 'flex', flexDirection: 'column', gap: '1rem' }}>
                    {extraDefaultComponents?.map(defaultComponent => {

                        return <div key={defaultComponent.benefitPlanCompSlotKey} style={{
                            padding: '1rem',
                            backgroundColor: 'var(--lightestGrey)',
                            borderRadius: '.4rem'
                        }}>
                            <p className="sub-title">SlotName: {defaultComponent.slotName}</p>
                            <p style={{ fontWeight: 600, padding: '.4rem 0rem .6rem 0rem' }}>{defaultComponent.benefitPlanCompName}</p>
                            <p className="sub-title">{defaultComponent.benefitPlanCompDesc}</p>

                        </div>
                    })}
                </div></> : <>
                <p style={{ fontSize: '1.2rem', fontWeight: '600', padding: '2rem 0rem 1rem 0rem' }}>Extra Riders</p>

                <div style={{ display: 'flex', gap: '1rem', padding: '0rem 0rem 1rem 0rem', alignItems: 'center' }}>

                    <div style={{ width: '40%' }}>
                        <Select
                            name={'category'}

                            className="react-select-container"
                            classNamePrefix="react-select"
                            placeholder={'Filter by category'}
                            // inputRef={field.ref}
                            options={categoriesOptions}
                            value={selectedCategoryOption} // Pass the state variable here
                            onChange={(option) => { setSelectedCategoryOption(option) }}
                        // value={options.find((c) => c.value === field.value)}
                        // onChange={(val) => field.onChange(val.value)}
                        />

                    </div>


                    <AsyncPaginate
                        placeholder={"Select a rider"}
                        className="react-select-container"
                        classNamePrefix={"react-select"}
                        debounceTimeout={300}

                        cacheUniqs={[selectedCategoryOption?.value, Date.now()]}
                        value={selectedRider}
                        onChange={setSelectedRider}

                        loadOptions={loadRiders}
                        additional={{
                            benefitPlanTemplateKey: template?.additional?.benefitPlanTemplateKey,
                            category: selectedCategoryOption?.value
                        }}
                        styles={customStyles}
                        components={{ Option: CustomOption }}
                        isClearable
                    />


                    <button className="btn add-btn"
                        disabled={!selectedRider}
                        onClick={() => {
                            insert(0, selectedRider)

                            setSelectedRider(null)
                            setSelectedCategoryOption(null)
                        }}>Add</button>
                </div>


                <div style={{ padding: '1rem 0rem', display: 'flex', flexDirection: 'column', gap: '1rem' }}>
                    {extraRidersFields.map((field, index) => (
                        <div key={field.id} style={{
                            padding: "1rem",
                            backgroundColor: "var(--lightestGrey)",
                            borderRadius: ".4rem",
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "start",

                        }}>
                            <div style={{ flex: 1 }}>
                                <p className="sub-title" style={{ paddingBottom: '.6rem' }}>{index + 1}. {field.additional.category}</p>
                                <p style={{ fontWeight: 600 }}>{field.label}</p>
                                <p className="sub-title">{field.additional.benefitPlanRiderDesc}</p>
                            </div>


                            <FaRegTrashCan style={{ cursor: 'pointer' }} size={"1.2rem"} color={"var(--red)"} onClick={() => remove(index)} />


                            {/* <ReactJson
                            style={{ padding: '1rem' }}
                            src={{ ...field, category: field.additional.category } || {}}
                            name={false}
                            collapsed={1}
                            collapseStringsAfterLength={150}
                            displayDataTypes={false}
                            displayObjectSize={false}
                            sortKeys={true}
                        /> */}

                        </div>


                        //   <div key={field.id} >

                        //         <ReactJson
                        //             style={{ padding: '1rem' }}
                        //             src={{ ...field, category: field.additional.category } || {}}
                        //             name={false}
                        //             collapsed={1}
                        //             collapseStringsAfterLength={150}
                        //             displayDataTypes={false}
                        //             displayObjectSize={false}
                        //             sortKeys={true}
                        //         />
                        //     </div>
                        //   <input
                        //     key={field.id} // important to include key with field's id
                        //     {...register(`extraRiders.${index}.value`)} 
                        //   />
                    ))}
                </div></>}



        </>
    )
}

export default StepEighteen


const CustomOption = (props) => {

    const { innerProps, label, data } = props
    return (
        <div {...innerProps} style={{ padding: '0.6rem 1rem ' }} className="dd-option">

            <p style={{ fontWeight: 600, fontSize: '.8rem' }}>{data?.account?.value}</p>
            <p>{label}</p>
            {/* {data.description && <small>{data.description}</small>} */}
        </div>
    )
};
